module.exports = __webpack_public_path__ + "static/media/profile.adff6294.jpeg";